// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__1UTMW","gfeWrapper":"CalendarEvent_gfeWrapper__3ZO1H"};